module.exports = __webpack_public_path__ + "img/shareBg2.cd9c41bd.png";